export enum PersonalizationViewMode {
  Desktop = 'desktop',
  Mobile = 'mobile',
};
